// extracted by mini-css-extract-plugin
module.exports = {"container":"choose-frequency-later-links-footer_container__1YjZc","footerIcon":"choose-frequency-later-links-footer_footerIcon__KB0PK"};